import { PaymentMethodsGenericActionsProps } from '../../../components/payment-methods/actions/actions-generic';
import { GatewaySwitch } from '../../../components/switches/gateway-switch';
import { usePaymentMethodsStripeContext } from '../context/payment-methods-stripe.context';

export type PaymentMethodsContextToAchActionsProps = {
  stripeComponent: React.FC<PaymentMethodsGenericActionsProps>;
  justifiComponent: React.FC<object>;
  shouldUsePadding?: boolean;
};
export const PaymentMethodsContextToAchActions = ({
  stripeComponent: StripeComponent,
  justifiComponent: JustifiComponent,
  shouldUsePadding,
}: PaymentMethodsContextToAchActionsProps) => {
  return (
    <GatewaySwitch
      stripeContent={StripeActionsWithContext}
      stripeProps={{ render: StripeComponent, shouldUsePadding }}
      justifiContent={JustifiActionsWithContext}
      justifiProps={{ render: JustifiComponent }}
    />
  );
};

const StripeActionsWithContext = ({
  render: StripeComponent,
  shouldUsePadding,
}: {
  render: React.FC<PaymentMethodsGenericActionsProps>;
  shouldUsePadding?: boolean;
}) => {
  const { achPrimary, achSecondary } = usePaymentMethodsStripeContext();

  return (
    <StripeComponent
      primary={achPrimary}
      secondary={achSecondary}
      shouldShow={true}
      shouldUsePadding={shouldUsePadding}
    />
  );
};

const JustifiActionsWithContext = () => {
  console.warn('Justifi ACH actions are not supported yet');
  return <></>;
};
